import { Get, Set } from "../../../../Request";

export const GetData = async pageNumber => {
  return await Get({
    url: "/item/search_web",
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const GetItem = async (slug,app) => {
  return await Get({
    url: "/item/single",
    data: {
      slug,
      app
    },
  }).then(data => {
    return data;
  });
};

export const SetBookMark = async data => {
  return await Get({
    url: "/favorite/favorite_toggle",
    data: {
      ...data,
    },
    stat: true,
  }).then(data => {
    return data;
  });
};

export const StoreComment = async data => {
  return await Set({
    url: "/comment/create",
    data: {
      ...data,
    },
  }).then(data => {
    return data;
  });
};
export const StoreReserve = async data => {
  return await Set({
    url: "/order/store",
    data: {
      ...data,
    },
  }).then(data => {
    return data;
  });
};

export const getProvinces = async () => {
  return await Get({
    url: "/province/show",

    toast: true,
  }).then(data => {
    return data;
  });
};

export const getCity = async id => {
  return await Get({
    url: "/city/show",
    data: { province_id: id },
  }).then(data => {
    return data;
  });
};
export const getRegion = async id => {
  return await Get({
    url: "/region/show",
    data: { city_id: id },
    toast: true,
  }).then(data => {
    return data;
  });
};

export const getCategory = async () => {
  return await Get({
    url: "/category/show_all",
    data: {},
  }).then(data => {
    return data;
  });
};

// export const BookMark = async data => {
//   return await Set({
//     url: "/favorite/favorite_toggle",
//     data: {
//       rel_id: data.Itemid,
//       rel_type: "Item",
//     },
//   }).then(data => {
//     return data;
//   });
// };

export const FormSearchSubmit = async (
  data = {},
  limit = 15,
  pageNumber = 1
) => {
  return await Get({
    url: `/item/search_web`,
    data: {
      limit: limit,
      ...data,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const FormRateSubmit = async data => {
  return await Set({
    url: "/rate/new",
    data: {
      score: data,
    },
  }).then(data => {
    return data;
  });
};
export const changeStatus = async data => {
  return await Get({
    url: "/item/change_status",
    data: {
      ...data,
    },
    stat: true,
  }).then(data => {
    return data;
  });
};
export const addSansCount = async data => {
  return await Get({
    url: "/item/sub_count",
    data: {
      ...data,
    },
    stat: true,
  }).then(data => {
    return data;
  });
};

export const GetMonth = async id => {
  return await Get({
    url: "/timetable/getmonth",
    data: {
      item_id: id,
    },
  }).then(data => {
    return data;
  });
};

export const GetDay = async data => {
  return await Get({
    url: "/timetable/getday",
    data: data,
  }).then(data => {
    return data;
  });
};

export const GetSans = async data => {
  return await Get({
    url: "/timetable/getsans",
    data: data,
  }).then(data => {
    return data;
  });
};
export const GetShifts = async data => {
  return await Get({
    url: "/timetable/showweeks",
    data: data,
  }).then(data => {
    return data;
  });
};

export const addShift = async (data, basket) => {
  let item;
  let exist = 1;
  let newBasket = basket || [];

  if (newBasket.length === 0) {
    item = {
      ...data,
      count: 1,
    };
  } else {
    newBasket.map(item => {
      if (item.shift_id === data.shift_id) {
        exist = item.count + 1;
      }
    });
    if (exist > 1) {
      newBasket = newBasket.filter(
        element => element.shift_id !== data.shift_id
      );
      item = {
        ...data,
        count: exist,
      };
    } else {
      item = {
        ...data,
        count: 1,
      };
    }
  }
  newBasket.push(item);
  return {
    local_storage: {
      key: "basket",
      value: newBasket,
    },
    type: "SET",
    payload: { basket: newBasket },
  };
};
export const addSans = async (data, basket) => {
  let item;
  let newBasket = basket || [];

  try {
    if (!basket) {
      basket = [];
    }
    let exist = 1;
    if (newBasket.length === 0) {
      item = {
        ...data,
        count: 1,
      };
      newBasket.push(item);
    } else {
      newBasket.forEach(element => {
        if (element.sans_id === data.sans_id && element.day === data.day) {
          exist++;
        }
      });
      if (exist > 1) {
        item = {
          ...data,
          count: 1,
        };
        newBasket.push(item);
        newBasket = newBasket.filter(
          element =>
            element.sans_id !== data.sans_id && element.day === data.day
        );
      } else {
        item = {
          ...data,
          count: 1,
        };
        newBasket.push(item);
      }
    }

    return {
      local_storage: {
        key: "basket",
        value: newBasket,
      },
      type: "SET",
      payload: { basket: newBasket },
    };
  } catch (error) {
    return false;
  }
};
